import React from 'react'

import type { ButtonProps } from '@ui/stickybid'
import { Button } from '@ui/stickybid'
import AddIcon from '@material-ui/icons/Add'
import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'

export interface AddItemButtonProps extends Omit<ButtonProps, 'classes'> {}

const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    background: 'white',
    '@media print': {
      display: 'none !important'
    }
  },
  icon: {
    fontSize: '1.0em',
    marginRight: theme.spacing()
  }
}))

export default function AddItemButton({ children, ...props }: AddItemButtonProps) {
  const classes = useStyles(props)

  return (
    <Button startIcon={<AddIcon />} prominence={4} {...props} classes={classes}>
      {children}
    </Button>
  )
}
